module.exports = __webpack_public_path__ + "0bf749af6a2f0a516d6182e4fef00244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile14.png
// module id = 1874
// module chunks = 0